import { Palette, Users, Flame, Move, Loader2 } from "lucide-react";

const Pill = ({ active, onClick, testId, Icon, children, tone = "primary" }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
      active
        ? tone === "heat" ? "bg-orange-500/15 border-orange-500 text-orange-500" : "bg-primary/15 border-primary text-primary"
        : "border-border text-muted-foreground hover:text-foreground"
    }`}
  >
    <Icon className="w-3.5 h-3.5" /> {children}
  </button>
);

export default function MapaToolbar({ mode, setMode, heatOn, setHeatOn, heatMetric, setHeatMetric, canEdit, editMode, setEditMode, geocodificando }) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-xs text-muted-foreground mr-1">Cor dos pinos:</span>
      <Pill active={mode === "situacao"} onClick={() => setMode("situacao")} testId="btn-mapa-modo-situacao" Icon={Palette}>Situação</Pill>
      <Pill active={mode === "consultor"} onClick={() => setMode("consultor")} testId="btn-mapa-modo-consultor" Icon={Users}>Consultor</Pill>
      <span className="w-px h-5 bg-border mx-1" />
      <Pill active={heatOn} onClick={() => setHeatOn(!heatOn)} testId="btn-mapa-calor" Icon={Flame} tone="heat">
        Mapa de calor {heatOn ? "ligado" : "desligado"}
      </Pill>
      {heatOn && (
        <div className="inline-flex rounded-full border border-border p-0.5" data-testid="mapa-calor-metrica">
          {[{ v: "clientes", label: "Clientes fechados" }, { v: "vendas", label: "Vendas realizadas" }].map(({ v, label }) => (
            <button key={v} type="button" onClick={() => setHeatMetric(v)} data-testid={`btn-calor-${v}`}
              className={`px-3 py-1 rounded-full text-[11px] font-semibold transition-colors ${heatMetric === v ? "bg-orange-500 text-white" : "text-muted-foreground hover:text-foreground"}`}>
              {label}
            </button>
          ))}
        </div>
      )}
      {canEdit && (
        <Pill active={editMode} onClick={() => setEditMode(!editMode)} testId="btn-mapa-ajustar" Icon={Move}>
          {editMode ? "Concluir ajuste" : "Ajustar pinos"}
        </Pill>
      )}
      {geocodificando && (
        <span className="flex items-center gap-1.5 text-xs text-sky-500 ml-auto" data-testid="mapa-geocodificando">
          <Loader2 className="w-3.5 h-3.5 animate-spin" /> Localizando endereços…
        </span>
      )}
    </div>
  );
}
